module.exports = __webpack_public_path__ + "static/11-IMG-0538-101cdef7fa002fe340df86b3df6effe5.png";